import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const STANDARD_2026 = 'standard_2026';
export const LEGACY_V1 = 'legacy_v1';

export const resolveExperience = (survey) =>
  survey?.presentation_version === STANDARD_2026 ? STANDARD_2026 : LEGACY_V1;

export const experienceLabel = (value) => (value === STANDARD_2026 ? 'Standard 2026' : 'Legacy');

export const isMysteryShoppingSurvey = (survey) =>
  survey?.survey_type === 'mystery_shopping' || survey?.product_type === 'mystery_shopping';

export const SurveyExperienceSetting = ({ survey, onChange }) => {
  const value = resolveExperience(survey);
  const isMS = isMysteryShoppingSurvey(survey);
  return (
    <div data-testid="settings-survey-experience">
      <label className="text-xs font-semibold text-[#334155] block mb-1.5">Survey Experience</label>
      <Select value={value} onValueChange={(v) => v !== value && onChange(v)} disabled={isMS}>
        <SelectTrigger data-testid="settings-survey-experience-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={STANDARD_2026} data-testid="experience-standard-2026">Standard 2026</SelectItem>
          <SelectItem value={LEGACY_V1} data-testid="experience-legacy">Legacy</SelectItem>
        </SelectContent>
      </Select>
      <p className="text-[11px] text-[#94A3B8] mt-1" data-testid="settings-survey-experience-help">
        {isMS
          ? 'Mystery Shopping uses the Legacy experience for now.'
          : value === STANDARD_2026
            ? 'The new responsive respondent experience. Preview and the live survey use it.'
            : 'The existing respondent experience. Preview and the live survey use it.'}
        {!isMS && survey?.status === 'active' && ' This survey is live — a change applies to respondents immediately.'}
      </p>
    </div>
  );
};
